import { module as BaseModule } from 'modujs';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.slider = null;
  }

  initSlider(ev) {
    this.slider = new Swiper( this.el.children[0], {
      modules: [ Autoplay, EffectFade, Pagination ],
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 600,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }
    } );
  }

  init() {
    this.initSlider();
  }
}
